import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { translations } from './translations';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      const saved = localStorage.getItem('rdaa_lang');
      return saved === 'es' ? 'es' : 'en';
    } catch (_) {
      return 'en';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('rdaa_lang', lang);
      document.documentElement.lang = lang;
    } catch (_) {
      /* localStorage unavailable */
    }
  }, [lang]);

  const value = useMemo(() => ({
    lang,
    setLang,
    toggle: () => setLang((prev) => (prev === 'en' ? 'es' : 'en')),
    t: translations[lang]
  }), [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used within LanguageProvider');
  return ctx;
};
